






































































// Vue
import { Component, Vue } from 'vue-property-decorator'

// Components
import { DataTable } from '../../table'
import { IsActive } from '@/components'

// services
import { DeviceService } from '@/services/config'

// Models
import { Paginator } from '@/models'
import { DeviceModel } from '@/models/config'

@Component({
    name: 'TableListDevices',
    components: {
        DataTable,
        IsActive
    }
})
export default class TableListDevices extends Vue {
    loading = false
    items: DeviceModel[] = []
    pagination: Paginator = {
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    }

    fields = [
        {
            key: 'name',
            sortable: true,
            label: 'Nombre'
        },
        {
            key: 'ip',
            sortable: true,
            label: 'IP'
        },
        {
            key: 'port',
            sortable: true,
            label: 'Puerto'
        },
        {
            key: 'amount_max_users',
            sortable: true,
            label: 'Empleados Registrados'
        },
        {
            key: 'amount_max_attendance',
            sortable: true,
            label: 'Asistencias Registradas'
        },
        {
            key: 'status_connection_text',
            sortable: true,
            label: 'Conexión'
        },
        {
            key: 'status_text',
            sortable: true,
            label: 'Status'
        },
        {
            key: 'actions',
            sortable: false,
            label: '',
            thClass: 'one-line w-30',
            thStyle: {
                width: '15%'
            }
        }
    ]

    created () {
        this.getDevicesWithPagination()
    }

    changePage (page: number) {
        this.pagination.currentPage = page
        this.getDevicesWithPagination()
    }

    changePerPage (perPage: number) {
        this.pagination.perPage = perPage
        this.pagination.currentPage = 1
        this.getDevicesWithPagination()
    }

    async getDevicesWithPagination () {
        this.loading = true
        const response = await DeviceService.getWithPagination(this.pagination.perPage, this.pagination.currentPage)
        this.items = response.objects
        this.pagination = response.pagination
        this.loading = false
    }
}
